import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function settingReducer(state = initialState.setting, action) {
  if (action.type === types.LOADED_SETTING_INFO_SUCCESS) {
    return action.setting;
  }
  return state;
}
